export const SET_TRIGGERS_TABLE_DESCRIPTION = 'SET_TRIGGERS_TABLE_DESCRIPTION';

export const setTriggersTableDescription = description => {
  return {
    type: SET_TRIGGERS_TABLE_DESCRIPTION,
    data: description,
  };
};
